import LoginPopin from './login-popin.component';

export default LoginPopin;
